export const convertToPercentage = (value: number) => {
  return (Math.round(value) / 100).toLocaleString("pt-BR", {
    style: "percent",
  });
};
